import { createSlice, PayloadAction } from "@reduxjs/toolkit";

/**
 * localStorage key under which the globally-selected site id is persisted so
 * the choice survives reloads. The `SiteSelector` component keeps this in sync
 * with the slice state (mirroring how `AuthProvider` persists `accessToken`).
 */
export const CURRENT_SITE_STORAGE_KEY = "currentSiteId";

const readPersistedSiteId = (): number | null => {
  const raw = localStorage.getItem(CURRENT_SITE_STORAGE_KEY);
  if (raw === null || raw === "") {
    return null;
  }
  const parsed = Number(raw);
  return Number.isFinite(parsed) ? parsed : null;
};

interface CurrentSiteState {
  currentSiteId: number | null;
}

const initialState: CurrentSiteState = {
  currentSiteId: readPersistedSiteId(),
};

const setCurrentSite = (
  state: CurrentSiteState,
  action: PayloadAction<number | null>,
): CurrentSiteState => ({
  ...state,
  currentSiteId: action.payload,
});

export const currentSiteSlice = createSlice({
  name: "currentSite",
  initialState,
  reducers: {
    setCurrentSite,
  },
});

export const currentSiteActions = {
  ...currentSiteSlice.actions,
};

export const currentSiteReducer = currentSiteSlice.reducer;

export default currentSiteReducer;
